<template>

    <div>
  
      <!-- <organization-list-add-new
        :is-add-new-organization-sidebar-active.sync="isAddNewOrganizationSidebarActive"
        :role-options="roleOptions"
        :plan-options="planOptions"
        @refetch-data="refetchData"
      /> -->
  
      <!-- Filters -->
      <!-- <organizations-list-filters
        :role-filter.sync="roleFilter"
        :plan-filter.sync="planFilter"
        :status-filter.sync="statusFilter"
        :role-options="roleOptions"
        :plan-options="planOptions"
        :status-options="statusOptions"
      /> -->
      <ebarimts-list-filters
        :ebarimt-filter.sync="ebarimtFilter"
        @print-ebarimt="isPrintModalVisible = true"
      />

      <!-- Print Modal -->
      <ebarimt-print-modal
        :visible.sync="isPrintModalVisible"
        @printed="refetchData"
      />

      <!-- Detail Modal -->
      <ebarimt-detail-modal
        :visible.sync="isDetailModalVisible"
        :ebarimt="selectedEbarimt"
      />

      <!-- Return Confirm Modal -->
      <b-modal
        id="return-confirm-modal"
        title="Баримт буцаах"
        ok-variant="danger"
        ok-title="Буцаах"
        cancel-title="Болих"
        centered
        @ok="handleReturn"
      >
        <p v-if="selectedReturnEbarimt">
          Та <strong>{{ selectedReturnEbarimt.ddtd }}</strong> дугаартай баримтыг буцаахдаа итгэлтэй байна уу?
        </p>
      </b-modal>

      <!-- Send Email Confirm Modal -->
      <b-modal
        id="send-email-confirm-modal"
        title="Имэйлээр илгээх"
        ok-variant="info"
        ok-title="Илгээх"
        cancel-title="Болих"
        centered
        @ok="handleSendEmail"
      >
        <p>Баримтыг имэйлээр илгээхдээ итгэлтэй байна уу?</p>
        <div v-if="selectedEmailEbarimt">
          <label>Имэйл хаяг</label>
          <b-form-input v-model="sendEmailAddress" placeholder="example@mail.com" />
        </div>
      </b-modal>

      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
  
        <div class="m-2">
  
          <!-- Table Top -->
          <b-row>
  
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Нэг хуудсанд</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label> бичлэг харуулах</label>
            </b-col>
  
            <!-- Search -->
            <!-- <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="invoice_number"
                  class="d-inline-block mr-1"
                  placeholder="1234-5678-9100"
                />
                <b-button
                  variant="primary"
                  @click="exportToExcel()"
                >
                  <span class="text-nowrap">Qpay шалгах</span>
                </b-button>
              </div>
            </b-col> -->
          </b-row>
  
        </div>
        <b-table
          ref="refReportDataTable"
          class="position-relative"
          :items="fetchEbarimtData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
  
          <!-- Column: Role -->
          <template #cell(amount)="data">
            <div class="text-nowrap">
              {{ formatCurrency(data.item.amount) }}
              <!-- {{ data.item.amount }} -->
            </div>
          </template>
  
          <!-- Column: Source -->
          <template #cell(source_id)="data">
            <b-badge
              pill
              :variant="data.item.source_id === 1 ? 'light-warning' : 'light-primary'"
            >
              {{ data.item.source_id === 1 ? 'Бонум' : 'Нөмөр' }}
            </b-badge>
          </template>

          <!-- Column: Status -->
          <template #cell(print_ebarimt)="data">
            <b-badge
              pill
              :variant="`light-${resolveOrganizationStatusVariant(data.item.print_ebarimt)}`"
              class="text-capitalize"
            >
              {{ data.item.print_ebarimt ? 'Хэвлэгдсэн': 'Хэвлэгдээгүй' }}
            </b-badge>
          </template>

          <template #cell(is_returned)="data">
            <b-badge
              pill
              :variant="`light-${resolveOrganizationStatusVariant(data.item.print_ebarimt)}`"
              class="text-capitalize"
            >
              {{ data.item.is_returned ? 'Буцаагдсан': 'Хэвийн' }}
            </b-badge>
          </template>
  
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button
              v-b-tooltip.hover
              title="Дэлгэрэнгүй"
              variant="flat-primary"
              size="sm"
              class="btn-icon"
              @click="showDetail(data.item)"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
            <b-button
              v-b-tooltip.hover
              title="Имэйлээр илгээх"
              variant="flat-info"
              size="sm"
              class="btn-icon"
              @click="confirmSendEmail(data.item)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              v-b-tooltip.hover
              title="Буцаах"
              variant="flat-danger"
              size="sm"
              class="btn-icon"
              @click="confirmReturn(data.item)"
            >
              <feather-icon icon="RotateCcwIcon" />
            </b-button>
          </template>
  
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
  
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Нийт {{ dataMeta.of }}-н {{ dataMeta.from }} - {{ dataMeta.to }} бичлэгийг  харуулж байна</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
  
              <b-pagination
                v-model="currentPage"
                :total-rows="totalOrganizations"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
  
            </b-col>
  
          </b-row>
        </div>
      </b-card>
    </div>
  </template>
  
  <script>
  import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BModal, VBTooltip,
  } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import store from '@/store'
  import { ref, onUnmounted, getCurrentInstance } from '@vue/composition-api'
  import { formatCurrency, avatarText } from '@core/utils/filter'
  import EbarimtsListFilters from './EbarimtsListFilters.vue'
  import EbarimtDetailModal from './EbarimtDetailModal.vue'
  import EbarimtPrintModal from './EbarimtPrintModal.vue'
  import useEbarimtsList from './useEbarimtsList'
  import ebarimtStoreModule from '../ebarimtStoreModule'
  import OrganizationListAddNew from './OrganizationListAddNew.vue'
  
  import { parseTime } from '@/utils'
  import parse from 'uuid/dist/parse'
  import { useToast } from 'vue-toastification/composition'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

  export default {
    directives: {
      'b-tooltip': VBTooltip,
    },
    components: {
      EbarimtsListFilters,
      EbarimtDetailModal,
      EbarimtPrintModal,
      OrganizationListAddNew,

      BCard,
      BModal,
      BRow,
      BCol,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BDropdown,
      BDropdownItem,
      BPagination,

      vSelect,
    },
    setup() {
      const toast = useToast()
      const EBARIMT_APP_STORE_MODULE_NAME = 'app-ebarimt'
  
      // Register module
      if (!store.hasModule(EBARIMT_APP_STORE_MODULE_NAME)) store.registerModule(EBARIMT_APP_STORE_MODULE_NAME, ebarimtStoreModule)
  
      // UnRegister on leave
      onUnmounted(() => {
        if (store.hasModule(EBARIMT_APP_STORE_MODULE_NAME)) store.unregisterModule(EBARIMT_APP_STORE_MODULE_NAME)
      })
  
      const root = getCurrentInstance().proxy

      const isAddNewOrganizationSidebarActive = ref(false)
      const isPrintModalVisible = ref(false)
      const isDetailModalVisible = ref(false)
      const selectedEbarimt = ref(null)

      const selectedReturnEbarimt = ref(null)
      const selectedEmailEbarimt = ref(null)
      const sendEmailAddress = ref('')

      const showDetail = (item) => {
        selectedEbarimt.value = item
        isDetailModalVisible.value = true
      }

      const confirmReturn = (item) => {
        selectedReturnEbarimt.value = item
        root.$bvModal.show('return-confirm-modal')
      }

      const handleReturn = () => {
        store
          .dispatch('app-ebarimt/returnReceipt', { receipt_id: selectedReturnEbarimt.value.id })
          .then(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Баримт амжилттай буцаагдлаа',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            refetchData()
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Баримт буцаахад алдаа гарлаа',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      }

      const confirmSendEmail = (item) => {
        selectedEmailEbarimt.value = item
        sendEmailAddress.value = item.email || ''
        root.$bvModal.show('send-email-confirm-modal')
      }

      const handleSendEmail = () => {
        if (!sendEmailAddress.value) {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Имэйл хаяг оруулна уу',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          })
          return
        }
        store
          .dispatch('app-ebarimt/sendReceiptEmail', {
            receipt_id: selectedEmailEbarimt.value.id,
            to_email: sendEmailAddress.value,
          })
          .then(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Имэйл амжилттай илгээгдлээ',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Имэйл илгээхэд алдаа гарлаа',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      }

      const roleOptions = [
        { label: 'Админ', value: 'admin' },
        { label: 'Эрхлэгч', value: 'author' },
        { label: 'Засварлагч', value: 'editor' },
        { label: 'Дэмжигч', value: 'maintainer' },
        { label: 'Дагагч', value: 'subscriber' },
      ]
  
      const planOptions = [
        { label: 'Үндсэн', value: 'basic' },
        { label: 'Байгууллага', value: 'company1' },
        { label: 'Аж ахуй нэгж', value: 'enterprise' },
        { label: 'Баг', value: 'team' },
      ]
  
      const statusOptions = [
        // { label: 'Хүлээгдэж буй', value: 'pending' },
        { label: 'Идэвхитэй', value: 'true' },
        { label: 'Идэвхигүй', value: 'false' },
      ]
  
      const {
        fetchEbarimtData,
        tableColumns,
        perPage,
        currentPage,
        totalOrganizations,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refReportDataTable,
        refetchData,
  
        // UI
        resolveOrganizationRoleVariant,
        resolveOrganizationRoleIcon,
        resolveOrganizationStatusVariant,
  
        // Extra Filters
        roleFilter,
        planFilter,
        statusFilter,
        ebarimtFilter
      } = useEbarimtsList()
  
      // const exportToExcel = () => {
      //   store
      //     .dispatch('app-report/fetchReportData', {
      //       "report_name": qpayFilter.value.report_name,
      //       "params": [
      //       qpayFilter.value.start_date, 
      //       qpayFilter.value.end_date
      //       ]
      //   })
      //     .then(response => {
      //        import('@/vendor/Export2Excel').then(excel => {
      //           excel.export_json_to_excel({
      //             header: response.data.response.reportHeader,
      //             data: response.data.response.reportData.map(x => response.data.response.reportHeader.map(y => { 
      //               if (y.includes("_at")) {
      //                 return parseTime(x[y])
      //               } 
      //               // else if (y.includes("_date")) {
      //               //   return parseTime(x[y])
      //               // } 
      //               // else if (y.includes("_time")) {
      //               //   return parseTime(x[y])
      //               // }
      //               else {
      //                 return x[y]
      //               }
      //             })),
      //             filename: 'ticket-' + qpayFilter.value.start_date + "-" + qpayFilter.value.end_date,
      //             autoWidth: true, //Optional
      //             bookType: 'csv' //Optional
      //           })
      //         })
      //     })
      //     .catch((error) => {
      //       console.log(error)
      //     })
      // }
  
      return {
  
        // Sidebar
        isAddNewOrganizationSidebarActive,

        // Print Modal
        isPrintModalVisible,

        // Detail Modal
        isDetailModalVisible,
        selectedEbarimt,
        showDetail,

        // Return Confirm
        selectedReturnEbarimt,
        confirmReturn,
        handleReturn,

        // Send Email
        selectedEmailEbarimt,
        sendEmailAddress,
        confirmSendEmail,
        handleSendEmail,
  
        fetchEbarimtData,
        tableColumns,
        perPage,
        currentPage,
        totalOrganizations,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refReportDataTable,
        refetchData,
        // exportToExcel,
        formatCurrency,
  
        // Filter
        avatarText,
  
        // UI
        resolveOrganizationRoleVariant,
        resolveOrganizationRoleIcon,
        resolveOrganizationStatusVariant,
  
        roleOptions,
        planOptions,
        statusOptions,
  
        // Extra Filters
        roleFilter,
        planFilter,
        statusFilter,
        ebarimtFilter
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  </style>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
  